import Point from './point';
export default class Segment {
    constructor(point = new Point(), handleIn = new Point(), handleOut = new Point()) {
        this.index = 0;
        this.featured = false;
        this.point = point.clone();
        this.handleIn = handleIn.clone();
        this.handleOut = handleOut.clone();
    }
    clone() {
        const segment = new Segment(this.point.clone(), this.handleIn.clone(), this.handleOut.clone());
        segment.index = this.index;
        segment.featured = this.featured;
        return segment;
    }
    transformCoordinates(coords) {
        let x = this.point.x;
        let y = this.point.y;
        let i = 2;
        coords[0] = x;
        coords[1] = y;
        if (this.handleIn) {
            coords[i++] = this.handleIn.x + x;
            coords[i++] = this.handleIn.y + y;
        }
        if (this.handleOut) {
            coords[i++] = this.handleOut.x + x;
            coords[i++] = this.handleOut.y + y;
        }
        return coords;
    }
}
//# sourceMappingURL=segment.js.map